// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_ARTICLE = "Opravdu chce\u0161 vymazat \u010dl\u00e1nek?";
export const ARTICLE_HAS_BEEN_DELETED = "\u010cl\u00e1nek byl vymaz\u00e1n.";
export const DONE = "Hotovo";
export const EXPLAIN_POST_DELETION = "Zadej bli\u017e\u0161\u00ed d\u016fvod:";
